export default __webpack_public_path__ + "static/media/review.babc457c.svg";